export default __webpack_public_path__ + "static/media/group-option-skincolor-unselected.942394ea.svg";